export const LOCAL_STORAGE_ENABLED_CLUSTERS_CREATION_KEY =
  "enableClustersCreation";

export const isEnableClustersCreation = () =>
  localStorage.getItem(LOCAL_STORAGE_ENABLED_CLUSTERS_CREATION_KEY) === "true";
